var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddWorkspace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFF2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.33203C16.0909 9.33203 15.7593 9.66367 15.7593 10.0728V15.258H10.5741C10.165 15.258 9.83337 15.5896 9.83337 15.9987C9.83337 16.4078 10.165 16.7394 10.5741 16.7394H15.7593V21.9246C15.7593 22.3337 16.0909 22.6654 16.5 22.6654C16.9091 22.6654 17.2408 22.3337 17.2408 21.9246V16.7394H22.426C22.8351 16.7394 23.1667 16.4078 23.1667 15.9987C23.1667 15.5896 22.8351 15.258 22.426 15.258H17.2408V10.0728C17.2408 9.66367 16.9091 9.33203 16.5 9.33203Z",
    fill: "#FF7A50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWorkspace);
export default __webpack_public_path__ + "static/media/addWorkspace.14037d0822745e804a25587f60506037.svg";
export { ForwardRef as ReactComponent };